import { UserRole } from "@prisma/client";

export const USER_ROLE_MAP = {
  Administrator: UserRole.ADMIN,
  Employee: UserRole.EMPLOYEE,
  Recruiter: UserRole.RECRUITER,
  Hr: UserRole.HR,
};
